module.exports = __webpack_public_path__ + "img/9b7a7a3.png";